import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface TipoDocumento {
  id: string;
  nome: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class TipoDocumentoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all tipo documentos
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: TipoDocumento[] }>(
        `${this.path}/getAllTipoDocumento`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  // Get tipo documento by ID
  public show(id: string): Observable<TipoDocumento> {
    return this.apiService
      .get<{ object: TipoDocumento }>(`${this.path}/getTipoDocumentoById/${id}`)
      .pipe(map((response) => response.object as TipoDocumento));
  }

  // Create new tipo documento
  public store(form: TipoDocumento): Observable<TipoDocumento> {
    const tipoDocumento = form as TipoDocumento;
    return this.apiService
      .post<{ object: TipoDocumento }>(`${this.path}/AddTipoDocumento`, tipoDocumento)
      .pipe(map((response) => response.object as TipoDocumento));
  }

  // Update existing tipo documento
  public update(form: FormGroup, id: string): Observable<TipoDocumento> {
    const tipoDocumento = form.value as TipoDocumento;
    return this.apiService
      .put<{ object: TipoDocumento }>(
        `${this.path}/UpdateTipoDocumento/${id}`,
        tipoDocumento
      )
      .pipe(map((response) => response.object as TipoDocumento));
  }

  // Delete existing tipo documento
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteTipoDocumentoById/${id}`);
  }
}
